/**
 * package: com.inq.flash.client.chatskins
 * class: FormMgr
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.FormMgr = function() {};
$hxClasses['com.inq.flash.client.chatskins.FormMgr'] = com.inq.flash.client.chatskins.FormMgr;
/** @private @type {Array} */
com.inq.flash.client.chatskins.FormMgr.__name__ = ["com","inq","flash","client","chatskins","FormMgr"];

/**
 * init
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.FormMgr.init = function() {
	return true;
};


/**
 * validateData
 *
 * $type TFun([{ name => dataElement, t => TType(js.FormElement,[]), opt => false },{ name => regex, t => TInst(String,[]), opt => true }],TEnum(Bool,[]))
 * private static function validateData( dataElement:js.FormElement, ?regex:String ):Bool
 * @private
 * @static
 * @param {js.FormElement}  dataElement 
 * @param {string}  regex 
 * @return {boolean}
 */
com.inq.flash.client.chatskins.FormMgr.validateData = function(dataElement,regex) {
	/** @type {boolean} */
	var  isValid = false;
	if(regex == null) isValid = true; else {
		/** @type {EReg} */
		var testReg = new EReg(regex,"");
		/** @type {string} */
		var dataType = "";
		
		try {
			dataType = StringTools.trim(dataElement.type.toLowerCase());
		} catch( unknown ) {
		}
		
		switch(dataType) {
			case "text":case "hidden":
				try {
					isValid = testReg.match(StringTools.trim(dataElement.value));
				} catch( unknown ) {
					isValid = false;
				}
				break;
			case "checkbox":case "radio":
				break;
			case "submit":case "reset":case "button":case "file":case "image":case "password":
				break;
			default:
		}
	}
	/* Nothing to do return false */
	return isValid;
};


/**
 * enableDisableElements
 *
 * $type TFun([{ name => formID, t => TInst(String,[]), opt => false },{ name => disable, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public static function  enableDisableElements(formID:String, disable:Bool)
 * @public
 * @static
 * @param {string}  formID 
 * @param {boolean}  disable 
 * @return {void}
 */
com.inq.flash.client.chatskins.FormMgr.enableDisableElements = function(formID,disable) {
	/** @type {HTMLCollection} */
	var el = window.document.getElementById(formID).getElementsByTagName("INPUT");
	for (var i = 0, l = el.length; i < l; i++) {
		el[i].disabled = disable;
	}
};


/**
 * getNextFormElement
 * Get next input element in this form
 *
 * $type TFun([{ name => elmnt, t => TType(js.HtmlDom,[]), opt => false }],TType(js.HtmlDom,[]))
 * private static function getNextFormElement(elmnt:HtmlDom):HtmlDom
 * @private
 * @static
 * @author Fred
 * @param {js.HtmlDom}  elmnt -  is the current element 
 * @return {js.HtmlDom} - returns the next input text or submit element or null 
 */
com.inq.flash.client.chatskins.FormMgr.getNextFormElement = function(elmnt) {
	/** @type {NodeList} */
	var  el = com.inq.flash.client.chatskins.FormMgr.getFormFromElement(elmnt).getElementsByTagName("INPUT");
	/** @type {number} */
	var  strt = el.length;
	/** @type {js.HtmlDom} */
	var nxtEl;
	for (var i = 0, len = el.length; i < len; i++) {
		if (el[i] == elmnt) {
			strt = i;
			break;
		}
	}
	
	/* now look for the next non hidden input element */
	while(++strt < el.length) {
		nxtEl = el[strt];
		if(nxtEl.type.toLowerCase() != "hidden") return nxtEl;
	}
	return null;
};


/**
 * getFormFromElement
 *
 * $type TFun([{ name => elmnt, t => TType(js.HtmlDom,[]), opt => false }],TType(js.HtmlDom,[]))
 * private static function getFormFromElement(elmnt:HtmlDom):HtmlDom
 * @private
 * @static
 * @param {js.HtmlDom}  elmnt 
 * @return {js.HtmlDom}
 */
com.inq.flash.client.chatskins.FormMgr.getFormFromElement = function(elmnt) {
	/** @type {js.HtmlDom} */
	var par = elmnt.parentNode;
	while(par != null) {
		if(par["tagName"] != null && par.tagName.toLowerCase() == "form") return par;
		par = par.parentNode;
	}
	return par;
};


/**
 * listen4ChangeElements
 *
 * $type TFun([{ name => formID, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private static function  listen4ChangeElements(formID:String)
 * @private
 * @static
 * @param {string}  formID 
 * @return {void}
 */
com.inq.flash.client.chatskins.FormMgr.listen4ChangeElements = function(formID) {
	/** @type {HTMLCollection} */
	var  el = com.inq.ui.Container.getElementById(formID).getElementsByTagName("INPUT");
	try {
		for (var i = 0, l = el.length; i < l; i++) {
			/** @type {HTMLElement} */
			var elmt = el[i];
			/* If the element is a submit button, then do the submit on the click
			 * and return false so the form does not do the submit
			 */
			if (elmt.type.toLowerCase() == "submit") {
				elmt.onchange = elmt.onkeypress = elmt.onclick = function(e) {
					/** @type {HTMLElement} */
					var el1 = this;
					com.inq.flash.client.chatskins.SkinControl.cw.syncForms();
					com.inq.flash.client.chatskins.FormMgr.submit(com.inq.flash.client.chatskins.FormMgr.getFormFromElement(el1).id);
					return false;
				};
			} else {
				/* We must check keydown for the enter key
				 * BTW: keyup is too late, the submit would be competed at keydown
				 *
				 * On enter go to next element, if next element is a submit, do the submit.
				 * if the next element is null, (when no submit button is supplied), then do the submit
				 */
				elmt.onkeydown = function(e) {
					/** @type {js.HtmlDom} */
					var  el1 = this;
					/** @type {boolean} */
					var  enterKey = false;
					/** @type {Event} */
					var  evnt = e != null?e:Application.application.getPanelWindow().event;
					if(evnt != null) enterKey = evnt.altKey == false && evnt.shiftKey == false && evnt.ctrlKey == false && evnt.keyCode == 13;

					if(enterKey) {
						/** @type {js.HtmlDom} */
						var  next = com.inq.flash.client.chatskins.FormMgr.getNextFormElement(el1);
						if(next == null || next.type.toLowerCase() == "submit") {
							com.inq.flash.client.chatskins.SkinControl.cw.syncForms();
							com.inq.flash.client.chatskins.FormMgr.submit(com.inq.flash.client.chatskins.FormMgr.getFormFromElement(el1).id);
						} else {
							com.inq.flash.client.chatskins.SkinControl.cw.syncForms();
							if(next.focus != null) next.focus();
						}
						return false;/* this meens, don't pass the keydown event to the next listener. */
					}

					return true;
				};

				elmt.onkeypress = elmt.onchange = elmt.onclick = function(e) {

					com.inq.flash.client.chatskins.SkinControl.cw.syncForms();
					return true;
				};
			}
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("Error " + Std.string(e),{ fileName : "FormMgr.hx", lineNumber : 152, className : "com.inq.flash.client.chatskins.FormMgr", methodName : "listen4ChangeElements"});
		} else throw(e);
	}
};


/**
 * disableAllElements
 *
 * $type TFun([{ name => cw, t => TInst(com.inq.flash.client.chatskins.ChatTextArea,[]), opt => false }],TEnum(Void,[]))
 * public static function disableAllElements( cw:ChatTextArea )
 * @public
 * @static
 * @param {com.inq.flash.client.chatskins.ChatTextArea}  cw 
 * @return {void}
 */
com.inq.flash.client.chatskins.FormMgr.disableAllElements = function(cw) {
	/** @type {HTMLCollection} */
	var el = com.inq.ui.Container.getElementById("chatWindow").getElementsByTagName("INPUT");
	for (var i = 0, l = el.length; i < l; i++) {
		el[i].disabled = true;
	}
};


/**
 * submit
 *
 * $type TFun([{ name => formID, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * public static function submit( formID:String ):Bool
 * @public
 * @static
 * @param {string}  formID 
 * @return {boolean}
 */
com.inq.flash.client.chatskins.FormMgr.submit = function(formID) {
	try {
		com.inq.flash.client.chatskins.BalloonNotifier.Clear();
		com.inq.flash.client.chatskins.FormMgr.enableDisableElements(formID,true);
		/** @type {HTMLElement} */
		var formToSubmit = com.inq.ui.Container.getElementById(formID);
		/** @type {HTMLCollection} */
		var formElements = formToSubmit.elements;
		/** @type {StringBuf} */
		var formData = new StringBuf();
		/** @type {boolean} */
		var submitForm = true;
		for (var i = 0, len = formElements.length; i < len; i++) {
			/** @type {boolean} */
			var isValid = true;
			/** @type {string} */
			var elementName = StringTools.trim(formElements[i].name);
			if (elementName != null && elementName.length > 0 && elementName != "test" && elementName != "pass" && elementName != "fail") {

				if (i + 1 < formElements.length && formElements[i + 1].name == "test") isValid = com.inq.flash.client.chatskins.FormMgr.validateData(formElements[i], formElements[i + 1].value);
				if (isValid) {
					formData.b += Std.string(formElements[i].name + "=" + StringTools.trim(formElements[i].value) + "&");
					if (i + 2 < formElements.length && formElements[i + 2].name == "pass") com.inq.flash.client.chatskins.BalloonNotifier.Notify(formElements[i], formElements[i + 2].value);
				} else {
					submitForm = false;
					if (i + 2 < formElements.length && formElements[i + 2].name == "fail") com.inq.flash.client.chatskins.BalloonNotifier.Warn(formElements[i], formElements[i + 2].value); else if (i + 3 < formElements.length && formElements[i + 3].name == "fail") com.inq.flash.client.chatskins.BalloonNotifier.Warn(formElements[i], formElements[i + 3].value);
				}
			}
		}
		
		if(submitForm) {
			com.inq.flash.client.chatskins.FormMgr.enableDisableElements(formID,true);
			com.inq.flash.client.chatskins.SkinControl.cw.syncForms();
			/** @type {string} */
			var dataString = HxOverrides.substr(formData.b,0,formData.b.length - 1);
			/** @type {string} */
			var displayMessage = com.inq.utils.Util.getConfig("sFormSubmitted","form submitted");
			com.inq.flash.client.chatskins.SkinControl.getApplicationController().submitForm(formToSubmit.name,formToSubmit.id,dataString,displayMessage);
		} else com.inq.flash.client.chatskins.FormMgr.enableDisableElements(formID,false);
	} catch( unknown ) {
		haxe.Log.trace("Form submission FAILED" + Std.string(unknown),{ fileName : "FormMgr.hx", lineNumber : 206, className : "com.inq.flash.client.chatskins.FormMgr", methodName : "submit"});
	}
	return false;
};


/**
 * updateFormFields
 *
 * $type TFun([{ name => formData, t => TInst(String,[]), opt => false },{ name => formName, t => TInst(String,[]), opt => false },{ name => formId, t => TInst(String,[]), opt => false },{ name => cw, t => TInst(com.inq.flash.client.chatskins.ChatTextArea,[]), opt => false }],TEnum(Void,[]))
 * public static function updateFormFields(formData:String, formName:String, formId:String, cw:ChatTextArea ):Void
 * @public
 * @static
 * @param {string}  formData 
 * @param {string}  formName 
 * @param {string}  formId 
 * @param {com.inq.flash.client.chatskins.ChatTextArea}  cw 
 * @return {void}
 */
com.inq.flash.client.chatskins.FormMgr.updateFormFields = function(formData,formName,formId,cw) {
	/** @type {HTMLElement} */
	var chatWindowDiv = com.inq.ui.Container.getElementById("chatWindow");
	/** @type {HTMLCollection} */
	var allForms = chatWindowDiv.getElementsByTagName("FORM");
	for (var i = 0, l = allForms.length; i < l; i++) {
		/** @type {HTMLElement} */
		var form = allForms[i];
		if (form.id == formId && form.name == formName || form.id == null && form.name == formName) {
			/** @type {string} */
			var rawFormValue = formData;
			/* Todo use dictionary and class to break string var formDataDict:Dictionary = StringUtils.parseQueryString(rawFormValue); */
			/** @type {Array} */
			var formValues = rawFormValue.split("&");
			for (var j = 0, len = formValues.length; j < len; j++) {
				/** @type {Array} */
				var elementData = formValues[j].split("=");
				/** @type {HTMLCollection} */
				var formElements = form.elements;
				for (var k = 0, length = formElements.length; k < length; k++) {
					if (formElements[k].name == elementData[0]) {
						formElements[k].setAttribute("value", elementData[1]);
						formElements[k].value = elementData[1];
						formElements[k].disabled = true;
					} else if (formElements[k].type.toLowerCase() == "submit") {
						formElements[k].disabled = true;
					}
				}
			}
		}
		cw.syncForms();
	}
};


/**
 * updateFormTimeExecutor
 * Execute updateForm with small delay.
 * Execution condition of updateForm: Object with id "chatWindow" should be exist.
 * If object doesn't exist it start delay of current method restart.
 *
 * $type TFun([{ name => cw, t => TInst(com.inq.flash.client.chatskins.ChatTextArea,[]), opt => false }],TEnum(Void,[]))
 * public static function updateFormTimeExecutor( cw:ChatTextArea ):Void
 * @public
 * @static
 * @param {com.inq.flash.client.chatskins.ChatTextArea}  cw 
 * @return {void}
 */
com.inq.flash.client.chatskins.FormMgr.updateFormTimeExecutor = function(cw) {
	/** @type {HTMLElement} */
	var chatWindowDiv = com.inq.ui.Container.getElementById("chatWindow");
	/* it's not possible to use chatWindowDiv in updateForm, because the forms are not updated/defined in DOM tree.*/
	/* wait of form update/initialization in DOM tree*/
	if (chatWindowDiv != null) {
		haxe.Timer.delay(function() {
			com.inq.flash.client.chatskins.FormMgr.updateForm(cw);
		},com.inq.flash.client.chatskins.ChatTextArea.RENDER_DELAY);
	} else {
		haxe.Timer.delay(function() {
			com.inq.flash.client.chatskins.FormMgr.updateFormTimeExecutor(cw);
		},com.inq.flash.client.chatskins.ChatTextArea.RENDER_DELAY);
	}
};


/**
 * updateForm
 *
 * $type TFun([{ name => cw, t => TInst(com.inq.flash.client.chatskins.ChatTextArea,[]), opt => false }],TEnum(Void,[]))
 * public static function updateForm( cw:ChatTextArea ):Void
 * @public
 * @static
 * @param {com.inq.flash.client.chatskins.ChatTextArea}  cw 
 * @return {void}
 */
com.inq.flash.client.chatskins.FormMgr.updateForm = function(cw) {
	/** @type {Element} */
	var chatWindowDiv = com.inq.ui.Container.getElementById("chatWindow");
	/** @type {HTMLCollection} */
	var  allForms = chatWindowDiv.getElementsByTagName("FORM");
	
	if(allForms.length > 0) {
		/** @type {Element} */
		var  form = allForms[allForms.length - 1];
		if(form.id == null || form.id == "") {
			form.id = "form_" + com.inq.flash.client.chatskins.FormMgr.randomNumber++;
			form.setAttribute("id",form.id);
		}
		if(form.action == null || form.action == "") {
			form.setAttribute("action","#")
		}
		com.inq.flash.client.chatskins.FormMgr.listen4ChangeElements(form.id);
	}
	cw.syncForms();
};

/** @type {com.inq.flash.client.chatskins.FormMgr} */
com.inq.flash.client.chatskins.FormMgr.prototype.__class__ = com.inq.flash.client.chatskins.FormMgr;
/** @private @type {com.inq.ui.Canvas} */
com.inq.flash.client.chatskins.FormMgr.chatCanvas = null;

/** @private @type {number} */
com.inq.flash.client.chatskins.FormMgr.randomNumber = 0;

